import React, { FC } from "react";
import ExpertSchedulerContextProvider from "../context/ExpertSchedulerContextProvider";
import ExpertScheduler from "./ExpertScheduler";

const ExpertExamsScheduler: FC = () => (
  <ExpertSchedulerContextProvider>
    <ExpertScheduler />
  </ExpertSchedulerContextProvider>
);

export default ExpertExamsScheduler;
